<div class="field-container">
  <div class="d-flex flex-column gap-3 flex-grow-1">
    <app-vb-withdrawal-percentage-input-label
      [fundName]="fundType?.name"
      [indicatorColour]="fundType?.colour"
      [balance]="balance" />
  </div>
  <div class="input-container">
    <app-percentage-input
      placeholder="0.00"
      [ngModel]="percentage"
      [disabled]="disabled"
      (valueChange)="handleValueChange($event)" />
  </div>
</div>
